function cov_1hns54ezz0() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DateChecked.tsx";
  var hash = "6c407941aea9b6b9b82c171f9abd06a3089dbab4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DateChecked.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6c407941aea9b6b9b82c171f9abd06a3089dbab4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1hns54ezz0 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1hns54ezz0();
var Icon = (cov_1hns54ezz0().s[0]++, {
  name: 'date-checked',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.75 3C8.75 2.30964 8.19036 1.75 7.5 1.75C6.80964 1.75 6.25 2.30964 6.25 3V5H5C3.34315 5 2 6.34315 2 8V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V8C22 6.34315 20.6569 5 19 5H17.75V3C17.75 2.30964 17.1904 1.75 16.5 1.75C15.8096 1.75 15.25 2.30964 15.25 3V5H8.75V3ZM6.25 7.5V7.9C6.25 8.59036 6.80964 9.15 7.5 9.15C8.19036 9.15 8.75 8.59036 8.75 7.9V7.5H15.25V7.9C15.25 8.59036 15.8096 9.15 16.5 9.15C17.1904 9.15 17.75 8.59036 17.75 7.9V7.5H19C19.2761 7.5 19.5 7.72386 19.5 8V19C19.5 19.2761 19.2761 19.5 19 19.5H5C4.72386 19.5 4.5 19.2761 4.5 19V8C4.5 7.72386 4.72386 7.5 5 7.5H6.25Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.7678 11.5L10.5 17.7678L7.23223 14.5L9 12.7322L10.5 14.2322L15 9.73223L16.7678 11.5Z\" fill=\"currentColor\"/>"
});
export default Icon;